import * as React from 'react';
import { BaseContext } from '../../../../../utils/basecontext';
import { ToneDto } from '../../../../../core/dto/tonedto';
import { ToneCardCSSStyle } from './tonecard/tonecardcssstyle';
import { AudioPlayerWithProgress, AudioPlayerWithProgressImpl } from '../../../../toolkit/player/playerwithprogress/playerwithprogressimpl';
import { ToneRowOptionsPrivilageImpl, ToneRowOptionsPrivilage } from '../../../../toolkit/toneoptions/tone/tonerowcomponent';
import { FeaturedCategoryToneCardCSSStyleImpl } from './tonecardcssstyle';
import { FeaturedCategoryToneEvenCardCSSStyleImpl } from './toneevencardcssstyle';
import { ToneCardPlayerCSSStyleImpl } from './tonecard/tonecardplayercss';
import { GridPaginationListViewModelImpl } from '../../../../toolkit/grid/gridpagination/gridpaginationlistviewmodel';
import { ToneMobileCardPlayerCSSStyleImpl } from './tonecard/tonemobilecardplayercss';
import { FeaturedCategoryToneCardComponent } from './tonecardcomponent';
// import { ToneMobileCardPlayerCSSStyleImpl } from './tonecard/tonemobilecardplayercss';

export class FeaturedToneRowOptionsImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setLike(true);
        this.setGift(true);
        this.setShare(true);
        this.setBuy(true);
        this.setDelete(false);
        this.setTellAFriend(true);
        this.setAddWishList(true);
        this.setPlay(true);
        this.setSettings(false);
        this.setAction(true);
    }
}

export class ProfileTunesFeaturedToneRowOptionsImpl extends ToneRowOptionsPrivilageImpl
{
    constructor()
    {
        super();

        this.setLike(false);
        this.setGift(false);
        this.setShare(false);
        this.setBuy(true);
        this.setDelete(false);
        this.setTellAFriend(false);
        this.setAddWishList(false);
        this.setPlay(true);
        this.setSettings(false);
        this.setAction(false);
    }
}

export class FeaturedToneListViewModelImpl extends GridPaginationListViewModelImpl<ToneDto>
{
    protected toneOddCardCSSStyle: ToneCardCSSStyle;
    protected toneEvenCardCSSStyle:ToneCardCSSStyle;
    
    
    private playerCSSStyle: ToneCardPlayerCSSStyleImpl;
    private playerMobileCSSStyle: ToneCardPlayerCSSStyleImpl;
  
    constructor(offset: string, private audioPlayerWithProgress: AudioPlayerWithProgress, private toneRowOptionsPrivilage: ToneRowOptionsPrivilage, context: BaseContext, private marginTop: string, title: string)
    {
        super(offset,context);
        this.onToneSelected = this.onToneSelected.bind(this);
        this.toneOddCardCSSStyle = new FeaturedCategoryToneCardCSSStyleImpl(context);
        this.toneEvenCardCSSStyle = new FeaturedCategoryToneEvenCardCSSStyleImpl(context);
        this.playerCSSStyle = new ToneCardPlayerCSSStyleImpl(context);

        this.playerMobileCSSStyle = new ToneMobileCardPlayerCSSStyleImpl(context);
    }

    getView(t: ToneDto, position: number): boolean | JSX.Element 
    {
        if(position % 2 === 0)
        {
            return <FeaturedCategoryToneCardComponent  mobilePlayerCSSStyle={this.playerMobileCSSStyle} playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneOddCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
        else
        {
            return <FeaturedCategoryToneCardComponent mobilePlayerCSSStyle={this.playerMobileCSSStyle}  playerCSSStyle={this.playerCSSStyle} onDeleteClicked={() => {}} toneRowOptionsPrivilage={this.toneRowOptionsPrivilage} marginTop={this.marginTop} audioPlayerWithProgress={this.audioPlayerWithProgress} cardStyle={this.toneEvenCardCSSStyle} key={position} onSelected={this.onToneSelected} context={this.getContext()} toneDto={t}  position={position}/>;

        }
    }

    

    setAudioProgress(): void
    {
        this.audioPlayerWithProgress = new AudioPlayerWithProgressImpl(this.getContext().getPlayerManager().getAudioPlayer());
    }
    protected onToneSelected(): void
    {
       
    }

  
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/featuredcategory/viewmodel/featuredcategorylistviewmodel.tsx